<template>
    <div id="ambis-meter">
        <v-breadcrumbs
            :items="[
                { text: 'Dashboard', to: { path: '/' } },
                { text: 'Ambis Meter', to: { path: '/ambis-meter' } },
                { text: 'Info' },
            ]"
            divider=">"
        ></v-breadcrumbs>
        <h3 class="header-text font-weight-bold">List Info Ambis Meter</h3>

        <v-card>
            <v-card-title>
                Info Ambis Meter
                <v-spacer></v-spacer>
                <v-btn
                    class="align-center text-body-2 blew white--text"
                    @click="$router.push({ path: '/info-form?baru=1' })"
                >
                    <v-icon small class="pr-2">mdi-plus-circle</v-icon>
                    Info
                </v-btn>
            </v-card-title>
            <v-divider />

            <app-datatable
                :items="infos"
                :headers="headers"
                :key="tableKey"
                :custom-pagination-total-items="infos.length"
                :custom-pagination-per-page="10"
                :custom-pagination-current-page="1"
                :custom-pagination-sort-mode="pagination.sortMode"
                :customWidth="true"
                v-on:selected="selectedRow = $event"
                v-on:dblClicked="editInfo()"
                v-on:changePage="
                    pagination = { ...pagination, currentPage: $event }
                "
                v-on:changeSortMode="
                    pagination = { ...pagination, sortMode: $event }
                "
                v-on:doSearch="
                    search = { query: $event.value, by: headersKey[$event.key] }
                "
            ></app-datatable>
        </v-card>

        <app-spinner v-if="isLoading"></app-spinner>
    </div>
</template>

<script>
import AppSpinner from "@/modules/global/components/plugins/Spinner";
import DataTable from "@/modules/global/components/plugins/DataTable-c";

export default {
    name: "info",

    components: {
        "app-datatable": DataTable,
        "app-spinner": AppSpinner,
    },

    data: function () {
        return {
            isLoading: false,
            selectedRow: null,
            search: null,
            tableKey: 0,
            pagination: {
                perPage: 1000,
                currentPage: 1,
                totalPages: 0,
                sortMode: "desc",
            },
            infos: [],
            datas: null,
            headers: [
                { text: "Pertanyaan", value: "question", max_width: "3px" },
                { text: "Jawaban", value: "answer" },
            ],
            headersKey: ["question", "answer"],
        };
    },

    mounted: function () {
        this.fetchData();
    },

    methods: {
        async fetchData() {
            var context = this;
            this.infos = [];

            try {
                const resp = await this.$alioss.get(
                    `/config/info_ambis_meter.json`,
                );
                this.datas = JSON.parse(resp.res.data).info;
                this.$store.commit("info_init", this.datas);
                this.$store.commit("info_init_raw", JSON.parse(resp.res.data));

                this.datas.forEach(function (info, index) {
                    var row = {
                        no: index,
                        id: info.id,
                        question: info.question,
                        answer: info.answer,
                        answer_detail: info.answer_detail,
                        datas: info,
                    };

                    context.infos.push(row);

                    context.isLoading = false;
                });
                context.isLoading = false;
            } catch (error) {
                // isLoading hanya direset di jalur sukses, jadi tanpa baris ini
                // spinner berputar selamanya saat OSS gagal.
                context.isLoading = false;
                alert(error);
            }
        },

        // createInfo: function () {
        //   this.$router.push({ path: "/info-form" });
        // },

        editInfo: function () {
            var context = this;
            // var infoId = this.selectedRow.id;
            this.$store.commit("info_onedit", this.selectedRow.datas);
            context.$router.push("/info-form");
        },
    },
};
</script>



// WEBPACK FOOTER //
// Info.vue?147f2e8a